/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import OrderNotes from "./orderNotes/orderNotes";
import Review from "./review/review";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import OrderPlaced from "./orderPlaced/orderPlaced";
import Loader from "../../../component/loader";
import { Routes, Route } from "react-router-dom";
import Catalog from "../catalog/catalog";
import Product from "../product/product";
import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";
import ManageCustomersHierarchy from "../manageCustomers/manageCustomersHierarchy";
import { withTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import Breadcrumb from "../../../component/breadcrumb";
import totalCalculator from "../../../helper/totalCalculatorNew";
import { Dialog, DialogContent, DialogTitle, DialogActions } from "@mui/material";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import Button from "../../../component/button";
// import { withStyles } from '@mui/styles';
import { withNavigation } from "../../../helper/withNavigation.js";

// Checkout steps:
// 0 :customerDetail
// 1 :Shipping option
// 2 :Notes
// 3 :review

// Checkout page main class
class Checkout extends Component {
  // Declare property values that belongs to the component
  state = {
    stage: 1,
    edit: false,
    customerDetails: {},
    notes: {},
    shippingOption: {},
    orderId: "",
    loading: false,
    orderAcc: [],
    orderSol: [],
    selectedTreeItems: [],
    selectedPaymentMethod: null,
    shipmentMethodTypeId: "",
    tenantId: "",
    orderStatus: "",
    bread: [
      {
        title:
          this.props.t("CHECKOUT") + ": " + this.props.t("SELECT_CUSTOMER"),
        url: "checkout",
      },
    ],
    showSelectCustomer: false,
    cartData: [],
    cartDataProxy: [],
    renderView: true,
    mode: "",
    onSelectCustomerCallback: null,
  };
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  }

  setSelectCustomerCallback = (callback) => {
    this.onSelectCustomerCallback = callback;
  };

  resetSelecteddata = () => {
    this.setState({
      customerDetails: {},
      selectedTreeItems: [],
      selectedPaymentMethod: null,
    });
  };

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  componentDidMount() {
    this.setState({
      mode: this.props.router.location.pathname,
    });
    if (
      this.props.solutionList.length > 0 ||
      this.props.shoppingCart.length > 0
    ) {
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        this.setState({
          tenantId: localStorage.getItem("selectedSalesChannel"),
        });
      }
      var preSelectedCustomer = JSON.parse(
        localStorage.getItem("preSelectedCustomer"),
      );
      var preSelectedPaymentMethod = JSON.parse(
        localStorage.getItem("preSelectedPaymentMethod"),
      );
      if (preSelectedCustomer && preSelectedCustomer.ban) {
        var tempCartData = JSON.parse(JSON.stringify(this.props.shoppingCart));
        this.setState({
          customerDetails: preSelectedCustomer,
          selectedPaymentMethod: preSelectedPaymentMethod,
          stage: 1,
          cartData: this.props.shoppingCart,
          cartDataProxy: tempCartData,
        });
      } else {
        this.props.router.navigate("/cart");
      }
    } else {
      this.props.router.navigate("/newOrder");
    }
  }

  // Go to next step and save previous step data
  next = (currStage, data, selectedTreeItems, selectedPaymentMethod) => {
    this.props.setErrorMessage("", false);
    if (currStage === 0) {
      // Select and Update Customer detail
      this.setState({
        customerDetails: data,
        stage: this.state.edit ? 2 : 1,
        selectedTreeItems: selectedTreeItems,
        selectedPaymentMethod: selectedPaymentMethod,
      });
      // this.setState({ loading: true })
      // let contact = {
      //     ...data
      // }
      // delete contact.billing;
      // delete contact.shipping;
      // delete contact.paymentInstrumentsMap;
      // delete contact.paymentMethod;
      // let banDetails = {
      //     accountName: data.accountName,
      //     ban: data.ban,
      //     partyId: data.partyId,
      //     label: data.label,
      //     value: data.ban,
      // }
      // let newData = {
      //     banDetails: banDetails,
      //     contact: contact,
      //     billing: data.billing,
      //     shipping: data.shipping,
      //     paymentInstrumentsMap: data.paymentInstrumentsMap ? data.paymentInstrumentsMap : null
      // }

      // BusApiCall('POST', `${constants.busInternalUrl}/customers`, newData).then(res => {
      //     let customerDetails = {};

      //     if (res.data.customer.paymentMethod && this.props.loggedInUserType != "ECOMMERCE_CUSTOMER") {
      //         customerDetails = {
      //             ...data,
      //             postalMechId: res.data.customer.postalMechId,
      //             partyId: res.data.customer.partyId,
      //             emailMechId: res.data.customer.emailMechId,
      //             officePhoneMechId: res.data.customer.officePhoneMechId,
      //             mobilePhoneMechId: res.data.customer.mobilePhoneMechId,
      //             shippingPhoneMechId: res.data.customer.shippingPhoneMechId,
      //             paymentMethod: JSON.parse(res.data.customer.paymentMethod)
      //         }
      //     } else {
      //         customerDetails = {
      //             ...data,
      //             //postalMechId: res.data.customer.postalMechId, //this is wrong
      //             partyId: res.data.customer.partyId,
      //             emailMechId: res.data.customer.emailMechId,
      //             officePhoneMechId: res.data.customer.officePhoneMechId,
      //             mobilePhoneMechId: res.data.customer.mobilePhoneMechId,
      //             shippingPhoneMechId: res.data.customer.shippingPhoneMechId
      //         }
      //         customerDetails.billing.postalMechId = res.data.customer.billing.postalMechId
      //         customerDetails.shipping.postalMechId = res.data.customer.shipping.postalMechId
      //     }
      //     this.setState({
      //         loading: false,
      //         edit: false,
      //         stage: this.state.edit ? 3 : 2,
      //     }, () => {
      //         this.setState({
      //             customerDetails: customerDetails
      //         }, () => {
      //         })
      //     })
      // })
      //     .catch(e => {
      //         if (e.response && e.response.data && e.response.data.message) {
      //             this.props.setErrorMessage(e.response.data.message, false)
      //         } else {
      //             this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
      //         }
      //         this.setState({
      //             loading: false
      //         })
      //     })
    } else if (currStage === 1) {
      this.setState({
        edit: false,
        stage: this.state.edit ? 2 : 2,
        notes: { ...data },
      });

      // Now do the auto discounting
      const {
        nowTotal,
        recTotal,
        nowDiscountedPrice,
        recDiscountedPrice,
        totalDiscount,
      } = totalCalculator([], this.props.solutionList, [], this.props.tenantId);
      let discounting_scheme = 0;
      let totalEligibleQuantity = 0;
      for (var i = 0; i < this.props.solutionList.length; i++) {
        let dis_sol = this.props.solutionList[i];
        if (
          dis_sol.id === "10226" ||
          dis_sol.id === "10312" ||
          dis_sol.id === "10329"
        ) {
          totalEligibleQuantity = totalEligibleQuantity + dis_sol.quantity;
        }
      }
      if (totalEligibleQuantity < 2) {
        for (var i = 0; i < this.props.solutionList.length; i++) {
          let dis_sol = this.props.solutionList[i];
          if (
            dis_sol.id === "10226" ||
            dis_sol.id === "10312" ||
            dis_sol.id === "10329"
          ) {
            this.props.changeDiscount(0, i, "SOL");
          }
        }
      }
      if (totalEligibleQuantity >= 2) {
        discounting_scheme = 1;
        let discounting_percent = 0;
        if (recTotal >= 75) {
          discounting_scheme = 2;
        }

        if (discounting_scheme == 1) {
          discounting_percent = 5;
        } else if (discounting_scheme == 2) {
          discounting_percent = 10;
        }
        for (var i = 0; i < this.props.solutionList.length; i++) {
          let dis_sol = this.props.solutionList[i];
          if (
            dis_sol.id === "10226" ||
            dis_sol.id === "10312" ||
            dis_sol.id === "10329"
          ) {
            this.props.changeDiscount(discounting_percent, i, "SOL");
          }
        }
      }
    }
  };

  // Go to previous step
  back = (currStage) => {
    this.props.setErrorMessage("", false);
    if (this.state.edit) {
      this.setState({
        edit: false,
        stage: this.state.edit ? 2 : 2,
      });
    } else {
      if (currStage === 0) {
        // Go back to cart
        this.props.router.navigate("/cart");
      } else if (currStage === 1) {
        // Got back to customer details
        this.setState({
          edit: false,
          stage: 0,
        });
      } else if (currStage === 2) {
        // Got back to customer details
        this.setState({
          edit: false,
          stage: 1,
        });
      } else if (currStage === 3) {
        // Got to agent id
        this.setState({
          edit: false,
          stage: 2,
        });
      }
    }
  };

  // Set info in edit mode on review order step
  edit = (editOption) => {
    window.scrollTo(0, 0);
    var preSelectedCustomer = JSON.parse(
      localStorage.getItem("preSelectedCustomer"),
    );
    if (editOption === 0 && preSelectedCustomer && preSelectedCustomer.ban) {
      this.setState({
        showSelectCustomer: true,
      });
    } else {
      this.setState({
        edit: true,
        stage: editOption,
      });
    }
  };

  closeDialog = () => {
    this.setState({
      showSelectCustomer: false,
    });
  };

  selectCustomerClose = (
    currStage,
    data,
    selectedTreeItems,
    selectedPaymentMethod,
  ) => {
    localStorage.setItem("preSelectedCustomer", JSON.stringify(data));
    localStorage.setItem(
      "preSelectedPaymentMethod",
      JSON.stringify(selectedPaymentMethod),
    );

    this.setState(
      {
        renderView: false,
        customerDetails: data,
        selectedTreeItems: selectedTreeItems,
        selectedPaymentMethod: selectedPaymentMethod,
        showSelectCustomer: false,
      },
      () => {
        this.setState({
          renderView: true,
        });
      },
    );
  };

  resetSelecteddataDialog = () => {};

  // Place order
  placeOrder = () => {
    var tempCartData = JSON.parse(JSON.stringify(this.props.shoppingCart));
    this.setState({
      cartDataProxy: tempCartData,
    });
    // Check for items
    if (
      this.props.solutionList.length === 0 &&
      this.props.accessoryList.length === 0 &&
      this.props.shoppingCart &&
      this.props.shoppingCart.length === 0 &&
      this.props.shoppingCart[0].cartItem.length === 0
    ) {
      this.props.setErrorMessage(
        this.props.t("NO_ITEMS_TO_ORDER_ERROR"),
        false,
      );
    } else {
      this.setState({ loading: true });
      let paymentMethodId = null;
      if (
        this.state.customerDetails.paymentMethod.creditCards &&
        this.state.customerDetails.paymentMethod.creditCards.length > 0
      ) {
        paymentMethodId =
          this.state.customerDetails.paymentMethod.creditCards[0]
            .paymentMethodId;
      } else if (
        this.state.customerDetails.paymentMethod.eftAccount &&
        this.state.customerDetails.paymentMethod.eftAccount.length > 0
      ) {
        paymentMethodId =
          this.state.customerDetails.paymentMethod.eftAccount[0]
            .paymentMethodId;
      } else if (this.state.customerDetails.paymentMethod) {
        paymentMethodId =
          this.state.customerDetails.paymentMethod.paymentMethodId;
      }

      // Get Custom accessories price data
      let customPriceData = "";
      for (let item of this.props.accessoryList) {
        if (item.customPrice) {
          customPriceData += item.id + "=" + item.price + ",";
        }
      }
      // Set order payload
      let orderPayload = {};
      // if (this.props.loggedInUserType === "ECOMMERCE_CUSTOMER") {
      //     // Set order payload
      //     orderPayload = {
      //         customerBan: JSON.parse(100000000), //TODO : for testing
      //         billingContactMechId: this.state.customerDetails.billing.postalMechId,
      //         shippingContactMechId: this.state.customerDetails.shipping.postalMechId,
      //         orderDate: new Date(),
      //         agentCode: this.state.notes.agentId,
      //         note: this.state.notes.notes,
      //         products: [],
      //         userData: [
      //             {
      //                 name: 'PORTAL_SEND_TNC_EMAIL',
      //                 value: 'true'
      //             }
      //         ]
      //     }
      //     if(paymentMethodId){
      //         orderPayload.paymentMethodId = paymentMethodId;
      //     }
      // }
      // else {
      orderPayload = {
        // customerBan: this.state.customerDetails.ban + '',
        relatedParty: [
          {
            id: this.state.customerDetails.ban + "",
            role: this.state.customerDetails.role,
          },
        ],
        billingContactMechId: this.state.customerDetails.billing.postalMechId,
        shippingContactMechId: this.state.customerDetails.shipping.postalMechId,
        orderDate: new Date(),
        agentCode:
          this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
          this.props.loggedInUserType === "ECOMMERCE_ADMIN"
            ? "CUST-AGENT"
            : this.state.notes.agentId,
        // note: this.state.notes.notes,
        note: [
          {
            text: this.state.notes.notes,
          },
        ],
        externalId: this.state.notes.externalId
          ? this.state.notes.externalId
          : "",
        productOrderItem: [],
        userData: [
          {
            name: "PORTAL_SEND_TNC_EMAIL",
            value:
              this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
              this.props.loggedInUserType === "ECOMMERCE_ADMIN"
                ? "false"
                : "true",
          },
          {
            name: "ORDER_ORIGINATOR",
            value: "Portal",
          },
          {
            name: "ORDER_CREATED_BY",
            value: this.props.providerType,
          },
          {
            name: "shipmentMethodTypeId",
            value: this.state.notes.shipmentMethodTypeId.split("|")[0].trim(),
          },
          {
            name: "carrierPartyId",
            value: this.state.notes.shipmentMethodTypeId.split("|")[1].trim(),
          },
        ],
      };
      if (paymentMethodId) {
        // orderPayload.paymentMethodId = paymentMethodId;
        orderPayload.payment = [
          {
            id: paymentMethodId,
          },
        ];
      }
      // }

      // Set custom accessories price data in payload
      if (customPriceData) {
        orderPayload.userData.push({
          name: "PORTAL_ACC_ORIDE_PRICES",
          value: customPriceData.substring(0, customPriceData.length - 1),
        });
      }
      let productList = [];
      let discountData = "";

      // Set products data in place order payload
      for (var i = 0; i < this.props.solutionList.length; i++) {
        if (this.props.solutionList[i].tenantId === this.props.tenantId) {
          var data = {};
          // Start: Set packaged solution data
          data.productId = this.props.solutionList[i].id;
          data.quantity = parseInt(this.props.solutionList[i].quantity);
          var spCode =
            this.props.solutionList[i].selectedPromo &&
            this.props.solutionList[i].selectedPromo.id
              ? this.props.solutionList[i].selectedPromo.id
              : "";
          if (spCode) {
            data.specialPricingCode = spCode;
          }
          if (
            this.props.solutionList[i].discount &&
            this.props.solutionList[i].discount > 0
          ) {
            discountData +=
              data.productId + "=" + this.props.solutionList[i].discount + ",";
          }

          // End: Set packaged solution data

          // Set promo id if have any
          if (this.props.solutionList[i].promoId) {
            data.specialPricingCode = this.props.solutionList[i].promoId;
          }

          data.associatedProducts = [];
          data.customProducts = [];
          var associatedItems = this.props.solutionList[i].associatedItems;
          for (var j = 0; j < associatedItems.length; j++) {
            var item = {
              productId: associatedItems[j].id,
              quantity: parseInt(associatedItems[j].quantity)
                ? parseInt(associatedItems[j].quantity)
                : 0,
            };
            if (associatedItems[j].selectedVariant) {
              item.selectedVariant = associatedItems[j].selectedVariant;
            }
            data.associatedProducts.push(item);
          }
          productList.push(data);
        }
      }

      // new order payload
      var psList = this.props.shoppingCart[0].cartItem;
      for (var i = 0; i < psList.length; i++) {
        var data = {
          productOffering: {},
        };
        data.productOffering.id = psList[i].productOffering.id;
        data.productOffering.quantity = parseInt(
          psList[i].productOffering.quantity,
        );

        var spCode =
          psList[i].productOffering.specialPricing &&
          psList[i].productOffering.specialPricing.id
            ? psList[i].productOffering.specialPricing.id
            : "";
        if (spCode) {
          data.productOffering.specialPricingCode = spCode;
        }

        data.productOffering.includedItems = [];
        // data.customProducts = [];
        if (
          psList[i].productOffering.locationDetail &&
          psList[i].productOffering.locationDetail.partyId
        ) {
          data.productOffering.location =
            psList[i].productOffering.locationDetail.partyId;
        }
        var includedItems = psList[i].productOffering.includedItems;
        for (var j = 0; j < includedItems.length; j++) {
          var item = {};
          var item = {
            id: includedItems[j].id,
            quantity: parseInt(includedItems[j].quantity)
              ? parseInt(includedItems[j].quantity)
              : 0,
          };
          // if (includedItems[j].locationDetail && includedItems[j].locationDetail.partyId) {
          //     item.location = includedItems[j].locationDetail.partyId;
          // }
          data.productOffering.includedItems.push(item);
        }
        productList.push(data);
      }

      // Set accessories data
      for (let item of this.props.accessoryList) {
        if (item.tenantId === this.props.tenantId) {
          if (item.type === "HANDW_ACC") {
          } else {
            let data = {
              productId: item.id,
              quantity: item.quantity ? item.quantity : 0,
            };
            productList.push(data);
          }
        }
      }
      orderPayload.productOrderItem = productList;

      // set the discount per packaged solution in user data
      if (discountData) {
        orderPayload.userData.push({
          name: "DISCOUNT",
          value: discountData.substring(0, discountData.length - 1),
        });
      }
      if (
        this.props.providerType === "SOLUTION_PROVIDER" &&
        this.state.tenantId
      ) {
        orderPayload.tenantId = this.state.tenantId;
      }
      console.log("final order payload", orderPayload);
      // Place order HTTP request
      BusApiCall("POST", `${constants.busV4Url}/orders`, orderPayload)
        .then((res) => {
          if (res.data.orderId) {
            this.clearCustomerCart(this.props.shoppingCart[0].id);
            window.scrollTo(0, this.myRef.current.offsetTop - 180);
            let orderAcc = [...this.props.accessoryList];
            let orderSol = JSON.parse(
              JSON.stringify([...this.props.solutionList]),
            );
            localStorage.removeItem("preSelectedCustomer");
            localStorage.removeItem("preSelectedPaymentMethod");
            this.props.setCart([]);
            this.setState(
              {
                stage: 3,
                orderId: res.data.orderId,
                orderStatus: res.data.orderStatus,
                loading: false,
                orderAcc,
                orderSol,
              },
              () => {
                this.props.clearCart();
                this.props.setPromoBan("");
              },
            );
          } else {
            this.props.setErrorMessage(res.data.message, false);
            this.setState({
              loading: false,
            });
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
          });
        });
    }
  };

  clearCustomerCart = (cartId) => {
    var jsonData = {};
    if (
      this.props.providerType === "SOLUTION_PROVIDER" &&
      this.state.tenantId
    ) {
      jsonData.tenantId = this.state.tenantId;
    }
    BusApiCall(
      "DELETE",
      `${constants.busPublicServiceUrl}/shoppingCart/${cartId}`,
      jsonData,
    )
      .then((res) => {})
      .catch((err) => {});
  };

  closeErrorMessage = (error, type) => {
    this.props.setErrorMessage(error, type);
  };

  onChangeCustomerOrderNumber = (e) => {
    var notes = { ...this.state.notes };
    notes.externalId = e;
    this.setState({
      notes: notes,
    });
  };
  inputAlphaNumeric = (e, callback) => {
    if (e.target.value.length < 21) {
      const value = e.target.value
        ? e.target.value.replace(/[^0-9a-zA-Z -]+/gi, "")
        : "";
      if (e.target.value !== value) {
        e.target.value = value;
      }
      if (typeof callback === "function") {
        return callback(value);
      }
    }
  };
  render() {
    // const sideMenu = JSON.parse(localStorage.getItem('sideMenu'));
    const sideMenu = this.props.sideMenu;
    const { classes: jssClasses } = this.props;
    return (
      <div style={sideMenu ? {} : { position: "relative" }}>
        {this.props.match.isExact ? (
          <main
            ref={this.myRef}
            style={sideMenu ? {} : { maxWidth: "1300px" }}
            className={sideMenu ? "checkoutWrapperSideMenu" : ""}
          >
            {this.state.stage === 0 ? (
              <>
                <ManageCustomersHierarchy
                  screen="checkout"
                  stage={this.state.stage}
                  next={this.next}
                  back={this.back}
                  selectedTreeItems={this.state.selectedTreeItems}
                  customerDetails={this.state.customerDetails}
                  selectedPaymentMethod={this.state.selectedPaymentMethod}
                  resetSelecteddata={this.resetSelecteddata}
                />
              </>
            ) : null}
            {this.state.stage === 1 ? (
              <OrderNotes
                edit={this.state.edit}
                stage={this.state.stage}
                next={this.next}
                back={this.back}
                notes={this.state.notes}
                sideMenu={sideMenu}
                shipmentMethodTypeId={this.state.shipmentMethodTypeId}
                loggedInUserType={this.props.loggedInUserType}
              />
            ) : null}
            {this.state.stage === 2 && this.state.renderView ? (
              <Review
                stage={this.state.stage}
                notes={this.state.notes}
                edit={this.edit}
                back={this.back}
                customerDetails={this.state.customerDetails}
                placeOrder={this.placeOrder}
                validator={this.closeErrorMessage}
                mode={this.state.mode}
                onChangeCustomerOrderNumber={this.onChangeCustomerOrderNumber}
                inputAlphaNumeric={this.inputAlphaNumeric}
              />
            ) : null}
            {this.state.stage === 3 ? (
              <OrderPlaced
                stage={this.state.stage}
                notes={this.state.notes}
                customerDetails={this.state.customerDetails}
                orderId={this.state.orderId}
                accessoryList={this.state.orderAcc}
                solutionList={this.state.orderSol}
                componentList={this.props.componentList}
                loggedInUserType={this.props.loggedInUserType}
                salesTenantId={this.state.tenantId}
                // orderStatus={this.state.orderStatus}
                orderStatus={"ORDER_COMPLETED"}
                cartData={this.state.cartDataProxy}
                onChangeCustomerOrderNumber={this.onChangeCustomerOrderNumber}
              />
            ) : null}

            {/* Select customer */}
            {this.state.showSelectCustomer && (
              <Dialog
                disableScrollLock={true}
                maxWidth={"lg"}
                PaperComponent={this.draggableDialogPaper}
                fullWidth={true}
                open={this.state.showSelectCustomer}
                aria-labelledby="import-dialog-title"
                PaperProps={
                  {
                    // className: jssClasses.resizablePaper
                  }
                }
              >
                <DialogTitle
                  id="draggableDialogPaper"
                  style={{ cursor: "move" }}
                >
                  {this.props.t("SELECT_CUSTOMER")}
                </DialogTitle>
                <DialogContent dividers style={{ height: "550px" }}>
                  <ManageCustomersHierarchy
                    screen="checkout"
                    subScreen="product"
                    stage={this.state.stage}
                    next={this.selectCustomerClose}
                    // back={this.back}
                    selectedTreeItems={this.state.selectedTreeItems}
                    customerDetails={this.state.customerDetails}
                    selectedPaymentMethod={this.state.selectedPaymentMethod}
                    resetSelecteddata={this.resetSelecteddataDialog}
                    closeDialog={this.closeDialog}
                    setSelectCallback={this.setSelectCustomerCallback}
                  />
                </DialogContent>
                <DialogActions>
                  <Button className='buttonSecondary' onClick={this.closeDialog}>{this.props.t("CANCEL")}</Button>
                  <Button onClick={() => this.onSelectCustomerCallback && this.onSelectCustomerCallback()}>{this.props.t("SELECT")}</Button>
                </DialogActions>
              </Dialog>
            )}

            <Loader loading={this.state.loading} />
          </main>
        ) : (
          <Routes>
            <Route exact path="/checkout/product" element={<Catalog />} />
            <Route
              path="/checkout/product/:id"
              element={(props) => <Product {...props} />}
            />
          </Routes>
        )}
      </div>
    );
  }
}

// const jssStyles = {
//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '60vw',
//     }
// }

const mapStateToProps = (state) => {
  return {
    solutionList: state.cart.solutions,
    accessoryList: state.cart.accessories,
    selectedPromoBan: state.cart.selectedPromoBan,
    componentList: state.cart.componentList,
    tenantId: state.auth.tenantId,
    loggedInUserType: state.auth.userLoginType,
    providerType: state.auth.providerType,
    shoppingCart: state.cart.shoppingCart,
    shoppingQuote: state.quote.shoppingQuote,
    sideMenu: state.auth.sideMenu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearCart: () => dispatch({ type: actionTypes.CLEAR_CART }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setPromoBan: (id) => dispatch({ type: actionTypes.CHECK_PROMO_BAN, id }),
    changeDiscount: (value, index, itemType, compType, compIndex) =>
      dispatch({
        type: actionTypes.CHANGE_DISCOUNT,
        value,
        index,
        itemType,
        compType,
        compIndex,
      }),
    setCart: (cart) => dispatch({ type: actionTypes.SET_CART, cart }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(Checkout)));

// export default Checkout
